import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import CallV2 from "../../service/axiosV2";
import {getUrl} from "../../constants/urls";

export const getEthernetConfigurationsAsync = ({mac_id}) => {
  const url = getUrl("ethernet_configurations")(mac_id);
  return trackPromise(Call.get(url));
};

export const editEthernetConfigurationsAsync = ({mac_id}, payload) => {
  const url = getUrl("editEthernet")(mac_id);
  return trackPromise(Call.post(url, payload));
};

export const getPortForwardingConfigurationsAsync = ({mac_id}) => {
  const url = getUrl("port_forwarding_configurations")(mac_id);
  return trackPromise(Call.get(url));
};

export const editPortForwardingConfigurationsAsync = ({mac_id}, payload) => {
  const url = getUrl("port_forwarding_configurations")(mac_id);
  return trackPromise(Call.post(url, payload));
};

export const resetPFConfigAsync = ({mac_id}) => {
  const url = getUrl("resetPortForward")(mac_id);
  return trackPromise(Call.post(url));
};

export const getModbusTcpIpAsync = ({mac_id}) => {
  const url = getUrl("modbus")(mac_id);
  return trackPromise(Call.get(url));
};

export const saveModbusTcpIpAsync = ({mac_id}, payload) => {
  const url = getUrl("modbus")(mac_id);
  return trackPromise(Call.post(url, payload));
};

export const getCellularModemAsync = ({mac_id}) => {
  const url = getUrl("cellularModem")(mac_id);
  return trackPromise(Call.get(url));
};

export const saveCellularModemAsync = ({mac_id}, payload) => {
  const url = getUrl("cellularModem")(mac_id);
  return trackPromise(Call.post(url, payload));
};

export const changeEmailTransmissionConfigAsync = ({mac, payload}) => {
  const url = getUrl("emailTransmission")(mac);
  return trackPromise(Call.post(url, payload));
};

export const getAquaticGroupProfilesAsync = (params) => {
  const url = getUrl("aquaticGroupProfiles");
  return trackPromise(CallV2.get(url, {params}));
};

export const addEditAquaticGroupProfileAsync = (payload) => {
  const {id = ""} = payload;
  const url = getUrl("aquaticGroupProfiles");
  if (id) {
    const patchUrl = `${url}${id}/`;
    return trackPromise(CallV2.patch(patchUrl, payload));
  }
  return trackPromise(CallV2.post(url, payload));
};
